export default __webpack_public_path__ + "static/media/revolut.0ae21533.png";